export function formatQueryParam(valor: any, nomeParametro: string): string {
  return valor ? `&${nomeParametro}=${valor}` : '';
}

export function formatQueryParamDate(data: Date, nomeParametro: string): string {
  if (!data) return '';
  const [y, m, d] = data.toISOString().substr(0, 10).split('-');
  return `&${nomeParametro}=${y}/${m}/${d}`;
}

export function formatarDataTexto(dataText: string, nomeParametro: string): string {
  if (!dataText) return '';
  const partes = dataText.split('/').reverse();
  return `${nomeParametro}=${partes[0]}/${partes[1]}/${partes[2]}`;
}
